import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from '../../../../styles/dggTheme';
import { breakpoint } from '../../../../styles/dontgiftguide.styles';

const { text, spacing } = dggTheme;

export const sectionCopy = css`
  margin: ${pxToRem(spacing.xl)} ${pxToRem(spacing.md)};
  font-size: ${pxToRem(text.HEADING.XS.fontSize)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      font-size: ${pxToRem(text.HEADING.MD.fontSize)};
    `,
  )};
`;
